import { reactive, toRefs } from '@vue/reactivity'
import { searchApi, courseApi } from '../plugins/axios'
import { headerSubtitle } from '../utils/externalDOMManipulation.js'

const state = reactive({
  typeProductList: [],
  resultItems: [],
  technologicalAreas: [],
  numPages: 0,
  loading: false,
  withoutResults: false,
  loadingResults: false,
  currentSort: 'Ordenar',
  orderingItems: [
    {
      id: 1,
      name: 'Nome',
    },
    {
      id: 2,
      name: 'Tipo de produto',
    },
    {
      id: 3,
      name: 'Área',
    },
  ],
  // request fields
  currentPage: 1,
  word: '',
  technologicalAreaId: null,
  typeProductListSelected: null,
  sort: null,
})

export function useSearch() {
  async function loadProductTypes() {
    state.loadingResults = true
    return await searchApi
      .get('tipo_produto')
      .then((response) => {
        response.data?.map((product) => {
          state.typeProductList.push({
            desc: product.desc,
            name: product.id,
            amount: 0,
            activate: false,
          })
        })
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        state.loadingResults = false
      })
  }

  async function loadTechnologicalArea() {
    state.loading = true
    return await courseApi
      .get('area_tecnologica', { params: { model: 'busca_geral' } })
      .then((response) => {
        state.technologicalAreas = renameObjKeys(response.data, 'nome', 'name')
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        state.loading = false
      })
  }

  function renameObjKeys(theObjArray, oldKey, newKey) {
    theObjArray = theObjArray.map((obj) => {
      obj[newKey] = obj[oldKey]
      delete obj[oldKey]
      return obj
    })
    return theObjArray
  }

  function mountRequestObjects(pageSize) {
    const body = {}
    decoratorOptions(body, 'nome', state.word)
    decoratorOptions(body, 'id_area_tecnologica', state.technologicalAreaId)
    decoratorOptions(body, 'ordenado_por', state.sort)
    decoratorOptions(body, 'tipo_produto', state.typeProductListSelected)

    const params = {}
    decoratorOptions(params, 'page', state.currentPage)
    decoratorOptions(params, 'page_size', pageSize)

    return { body, params }
  }

  async function loadSearch(pageSize = 5) {
    state.loadingResults = true
    const { body, params } = mountRequestObjects(pageSize)
    return await searchApi
      .post('buscar', body, { params })
      .then((response) => {
        if (response.data.count >= 1) {
          state.withoutResults = false
          state.resultItems = response.data.results
          state.numPages = response.data.num_pages
          setProductTypeAmounts(response)
          headerSubtitle(response.data.count, state.word)
        } else {
          state.withoutResults = true
          state.resultItems = []
          state.numPages = 0
          setProductTypeAmounts(response)
          headerSubtitle(response.data.count, state.word)
        }
        reloadProductTypes(response.data.qtd_tipo_produto)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        state.loadingResults = false
      })
  }

  function reloadProductTypes(products) {
    const list = []
    let allAreReset = 1

    for (const product in products) {
      if (products[product] > 0) allAreReset = 0
      for (const selectedProduct in state.typeProductListSelected) {
        // se for o mesmo produto e estiver zerado
        if (
          product === state.typeProductListSelected[selectedProduct] &&
          products[product] === 0
        ) {
          // armazeno o index dele na lista
          list.push(state.typeProductListSelected[selectedProduct])
        }
      }
    }

    // delete nos items que estão zerados
    list.forEach((product) => {
      state.typeProductListSelected.splice(
        state.typeProductListSelected.indexOf(product),
        1,
      )
    })

    // remove a marcação do mesmo no combo box
    for (const typeProduct in state.typeProductList) {
      for (const newProduct in products) {
        if (
          state.typeProductList[typeProduct].name === newProduct &&
          products[newProduct] === 0 &&
          !allAreReset
        ) {
          state.typeProductList[typeProduct].activate = false
        }
      }
    }
  }

  function setProductTypeAmounts(response) {
    state.typeProductList.forEach((element) => {
      for (const nameProduct in response.data.qtd_tipo_produto) {
        if (element.name === nameProduct) {
          element.amount = response.data.qtd_tipo_produto[nameProduct]
        }
      }
    })
  }

  function decoratorOptions(obj, key, value) {
    const isArray = Array.isArray(value)
    if (isArray && value.length >= 1) obj[key] = value
    else if (!isArray && value) obj[key] = value
  }

  function resetPagination() {
    state.currentPage = 1
  }

  function cleanFilter() {
    state.currentPage = 1
    state.sort = null
    state.technologicalAreaId = null
    state.typeProductListSelected = []
    state.word = ''
  }

  return {
    ...toRefs(state),
    loadProductTypes,
    loadTechnologicalArea,
    loadSearch,
    resetPagination,
    cleanFilter,
  }
}
